import Company from 'modules/core/store/models/Company'
import LegalEntity from 'modules/core/store/models/LegalEntity'

import Taxonomy from 'modules/contracts/store/models/Taxonomy'
import Employee from 'modules/employees/store/models/Employee'
import Location from 'modules/locations/store/models/Location'
import { SplitCustomTimeRangeCategory } from 'modules/payroll_bundle/pages/settings/ZucchettiIntegration/split_custom_time_range_categories/useSplitTimeSettingsCustomTimeRangeCategories'
import type { Codeable, Target } from 'modules/payroll_integrations/lib/types'
import { CustomTimeRangeCategory } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'
import LeaveType from 'modules/timeoff/store/models/LeaveType'

import CodeForm from './form'

const buildName = (target: Target) => {
  if (target instanceof Taxonomy) {
    return `${target.attributes.name} (${target.legalEntity?.attributes.legal_name})`
  } else if (target instanceof LegalEntity) {
    return target.attributes.legal_name
  } else if (target instanceof LeaveType) {
    return target.attributes.translated_name
  } else if (target instanceof Location) {
    return target.attributes.name
  } else if (target instanceof Company) {
    return target.attributes.name
  } else if (target instanceof CustomTimeRangeCategory) {
    return `${target.name} (${target.timeType})`
  } else if (target instanceof SplitCustomTimeRangeCategory) {
    return `${target.name} (${target.timeType})`
  } else if ('__typename' in target) {
    if (target.__typename === 'CompaniesLegalEntity') {
      return target.legalName
    }
    if (target.__typename === 'LocationsLocation') {
      return target.name
    }
    if (target.__typename === 'TimeoffLeaveType') {
      return target.translatedName || target.name
    }
    if (target.__typename === 'TimeSettingsSplitCustomTimeRangeCategory') {
      return `${target.name} (${target.timeType})`
    }
    /* TODO:
     *   Should refactor as employee is not needed
     * build form called from hooks.js build the field
     * with no need of label different from settings on
     * app integrations.
     */
  } else if (target instanceof Employee) {
    return 'Employee'
  }
}

const buildForm = (
  target: Target,
  targetType: string,
  targetLabel: string,
  integration: string,
  forfait_jours: boolean,
  position: number | null | undefined = undefined
): CodeForm => {
  return new CodeForm({
    codeable_id: target.id,
    codeable_name: buildName(target),
    codeable_type: targetType,
    codeable_label: targetLabel,
    integration: integration,
    forfait_jours: forfait_jours,
    position: position,
  })
}

const codesFormFactory = async (codeables: Record<string, Codeable>, integration: string) => {
  let forms: CodeForm[] = []

  for (const key in codeables) {
    const codeable_hash = codeables[key]

    if (!codeable_hash) {
      throw new Error('Codeable hash is required')
    }

    const codeable_collection = codeable_hash.collection

    const codeableForms = codeable_collection.map((codeable) =>
      buildForm(
        codeable,
        codeable_hash.class ?? '',
        codeable_hash.label ?? '',
        integration,
        codeable_hash.forfait_jours ?? false,
        codeable_hash.position
      )
    )
    forms = [...forms, ...(codeableForms ?? [])]
  }

  return forms
}

export { codesFormFactory, buildForm }
